/* Lumenix carrousel (desktop) en doorlopende rij. Zie lx-base.css voor de markup.
   - Pijlen scrollen één kaart verder; na de laatste terug naar de eerste en andersom.
   - Pijlen alleen tonen als de rij echt breder is dan het venster.
   - Schuifrijen zijn op desktop met de muis te verslepen (zie initSleep).
   - .lx-loop: loopt vanzelf door en is te verslepen (zie initLoop). */
(function () {
  function init(root) {
    if (root.dataset.lxCarrouselKlaar) return;
    root.dataset.lxCarrouselKlaar = '1';
    var rij = root.querySelector('[data-lx-carrousel-rij]');
    var pijlen = root.querySelector('[data-lx-carrousel-pijlen]');
    if (!rij || !pijlen) return;
    function stap() {
      var k = rij.children[0];
      if (!k) return 0;
      var gap = parseFloat(getComputedStyle(rij).columnGap || getComputedStyle(rij).gap) || 0;
      return k.getBoundingClientRect().width + gap;
    }
    function zichtbaar() {
      pijlen.hidden = !(window.matchMedia('(min-width: 1024px)').matches && rij.scrollWidth > rij.clientWidth + 1);
    }
    function ga(richting) {
      var max = rij.scrollWidth - rij.clientWidth;
      var doel = rij.scrollLeft + richting * stap();
      if (richting > 0 && rij.scrollLeft >= max - 4) doel = 0;
      if (richting < 0 && rij.scrollLeft <= 4) doel = max;
      rij.scrollTo({ left: doel, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    var v = pijlen.querySelector('[data-lx-vorige]');
    var n = pijlen.querySelector('[data-lx-volgende]');
    if (v) v.addEventListener('click', function () { ga(-1); });
    if (n) n.addEventListener('click', function () { ga(1); });
    zichtbaar();
    window.addEventListener('resize', zichtbaar);
  }
  /* Doorlopende rij (.lx-loop), sinds 14-10-2026 (Dion: «mensen moeten hier zelf doorheen kunnen swipen»):
     loopt rustig vanzelf (25 px per seconde) en is met vinger of muis te verslepen, met uitglijden na loslaten.
     Stil zolang je hem aanraakt en 2,5 s daarna, en zolang de muis erop staat of de focus erin zit. De baan bevat
     de kaarten twee keer; de positie loopt rond over één set (d). Startpositie: de sectie zet data-fase (0-1, zoals
     de oude animatie-vertraging) en stuurt 'lx-loop:fase'. Verticaal scrollen blijft van de browser
     (touch-action: pan-y). Minder beweging: geen script; de CSS laat de rij dan zelf scrollen. */
  var SNELHEID = 25, WACHT = 2500;
  function initLoop(el) {
    if (el.dataset.lxLoopKlaar) return;
    el.dataset.lxLoopKlaar = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var baan = el.querySelector('.lx-loop__baan');
    if (!baan) return;
    var richting = el.dataset.richting === 'rechts' ? -1 : 1;
    var x = 0, v = 0, d = 0, vorige = 0, rust = 0, muis = false, focus = false, zicht = true, loopt = false;
    var sleep = null, gesleept = false;
    function periode() {
      var k = baan.children, h = k.length / 2;
      return h && k[h] ? k[h].offsetLeft - k[0].offsetLeft : 0;
    }
    function teken() {
      if (d > 0) x = ((x % d) + d) % d;
      baan.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';
    }
    function zetFase() {
      d = periode();
      var f = parseFloat(el.dataset.fase);
      if (!d || isNaN(f)) return;
      x = richting > 0 ? f * d : (1 - f) * d;
      teken();
    }
    function stap(t) {
      var dt = vorige ? Math.min((t - vorige) / 1000, 0.1) : 0;
      vorige = t;
      if (!d) d = periode();
      if (!sleep && d) {
        if (Math.abs(v) > 5) {
          x += v * dt;
          v *= Math.pow(0.04, dt);
        } else {
          v = 0;
          if (!muis && !focus && t > rust) x += richting * SNELHEID * dt;
        }
        teken();
      }
      if (zicht) requestAnimationFrame(stap);
      else { loopt = false; vorige = 0; }
    }
    function start() {
      if (loopt) return;
      loopt = true;
      vorige = 0;
      requestAnimationFrame(stap);
    }
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      sleep = { id: e.pointerId, start: e.clientX, x0: x, lx: e.clientX, lt: e.timeStamp };
      v = 0;
      gesleept = false;
    });
    el.addEventListener('pointermove', function (e) {
      if (!sleep || e.pointerId !== sleep.id) return;
      var dx = e.clientX - sleep.start;
      if (!gesleept) {
        if (Math.abs(dx) < 6) return;
        gesleept = true;
        el.classList.add('is-slepen');
        try { el.setPointerCapture(e.pointerId); } catch (fout) {}
      }
      var dt = (e.timeStamp - sleep.lt) / 1000;
      if (dt > 0) v = Math.max(-3000, Math.min(3000, 0.8 * (-(e.clientX - sleep.lx) / dt) + 0.2 * v));
      sleep.lx = e.clientX;
      sleep.lt = e.timeStamp;
      x = sleep.x0 - dx;
      teken();
    });
    function los(e) {
      if (!sleep || e.pointerId !== sleep.id) return;
      if (!gesleept || e.type === 'pointercancel' || e.timeStamp - sleep.lt > 100) v = 0;
      sleep = null;
      el.classList.remove('is-slepen');
      rust = performance.now() + WACHT;
    }
    el.addEventListener('pointerup', los);
    el.addEventListener('pointercancel', los);
    el.addEventListener('click', function (e) {
      if (gesleept) { e.preventDefault(); e.stopPropagation(); gesleept = false; }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') muis = true; });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') muis = false; });
    el.addEventListener('focusin', function () { focus = true; });
    el.addEventListener('focusout', function () { focus = false; });
    el.addEventListener('lx-loop:fase', zetFase);
    window.addEventListener('resize', function () { d = periode(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (items) {
        zicht = items[0].isIntersecting;
        if (zicht) start();
      }).observe(el);
    }
    zetFase();
    start();
  }
  /* Slepen met de muis (desktop), sinds 14-10-2026 (Dion: «Swipen zelf moet ook mogelijk zijn»). Een schuifrij
     (.lx-carrousel__rij, .lx-ugc__rij) is met de muis te verslepen, zoals vegen op een telefoon of trackpad; dat
     laatste blijft van de browser, dit script doet alleen de muis. Tijdens het slepen staat scroll-snap uit
     (.is-slepen in lx-base.css); na loslaten glijdt de rij naar het dichtstbijzijnde vastklikpunt, met een zwiep
     verder, en daarna gaat snap weer aan. Dan volgt het event 'lx:sleep-klaar' op de rij (lx-ugc zet daarop een
     doorlopende rij terug in de echte set). Een klik na slepen telt niet. Niet vanaf een video met bediening (de
     tijdbalk) of een invoerveld. Alleen vanaf 1024 en alleen als de rij echt opzij scrollt. */
  function initSleep(rij) {
    if (rij.dataset.lxSleepKlaar) return;
    rij.dataset.lxSleepKlaar = '1';
    var desktop = window.matchMedia('(min-width: 1024px)');
    var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
    var sleep = null, gesleept = false, doel = null, veiligheid = 0, stilTimer = 0;
    function kan() {
      if (!desktop.matches) return false;
      var o = getComputedStyle(rij).overflowX;
      return (o === 'auto' || o === 'scroll') && rij.scrollWidth > rij.clientWidth + 1;
    }
    function markeer() { rij.classList.toggle('lx-sleepbaar', kan()); }
    function maat(w) { var n = parseFloat(w); return isNaN(n) ? 0 : n; }
    /* Scrollposities waarop een kaart vastklikt, uit scroll-snap-align en scroll-padding van de rij zelf. */
    function punten() {
      var cs = getComputedStyle(rij);
      var pl = maat(cs.scrollPaddingLeft), pr = maat(cs.scrollPaddingRight);
      var r = rij.getBoundingClientRect();
      var max = rij.scrollWidth - rij.clientWidth;
      var uit = [];
      Array.prototype.forEach.call(rij.children, function (k) {
        var b = k.getBoundingClientRect();
        if (!b.width) return;
        var a = getComputedStyle(k).scrollSnapAlign.split(' ').pop();
        var links = b.left - r.left - rij.clientLeft + rij.scrollLeft;
        var p;
        if (a === 'start') p = links - pl;
        else if (a === 'center') p = links + b.width / 2 - (pl + (rij.clientWidth - pl - pr) / 2);
        else if (a === 'end') p = links + b.width - (rij.clientWidth - pr);
        else return;
        uit.push(Math.max(0, Math.min(max, p)));
      });
      return uit;
    }
    function klaar() {
      clearTimeout(veiligheid);
      clearTimeout(stilTimer);
      rij.removeEventListener('scroll', opGlij);
      doel = null;
      rij.classList.remove('is-slepen');
      rij.dispatchEvent(new CustomEvent('lx:sleep-klaar'));
    }
    /* Uitglijden is klaar als de rij op het doel staat en even stil is (scrollend kent niet elke browser). */
    function opGlij() {
      clearTimeout(stilTimer);
      stilTimer = setTimeout(function () {
        if (doel === null || Math.abs(rij.scrollLeft - doel) < 2) klaar();
      }, 120);
    }
    rij.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !kan()) return;
      var t = e.target instanceof Element ? e.target : null;
      if (t && t.closest('input, textarea, select, video[controls]')) return;
      if (doel !== null) klaar();
      sleep = { id: e.pointerId, x: e.clientX, s: rij.scrollLeft, lx: e.clientX, lt: e.timeStamp, v: 0 };
      gesleept = false;
    });
    rij.addEventListener('pointermove', function (e) {
      if (!sleep || e.pointerId !== sleep.id) return;
      var dx = e.clientX - sleep.x;
      if (!gesleept) {
        if (Math.abs(dx) < 6) return;
        gesleept = true;
        rij.classList.add('is-slepen');
        try { rij.setPointerCapture(e.pointerId); } catch (fout) {}
        var sel = window.getSelection && window.getSelection();
        if (sel && sel.removeAllRanges) sel.removeAllRanges();
      }
      var dt = e.timeStamp - sleep.lt;
      if (dt > 0) sleep.v = 0.8 * ((e.clientX - sleep.lx) / dt) + 0.2 * sleep.v;
      sleep.lx = e.clientX;
      sleep.lt = e.timeStamp;
      rij.scrollLeft = sleep.s - dx;
    });
    function los(e) {
      if (!sleep || e.pointerId !== sleep.id) return;
      var v = e.type === 'pointercancel' || e.timeStamp - sleep.lt > 100 ? 0 : sleep.v;
      sleep = null;
      if (!gesleept) return;
      setTimeout(function () { gesleept = false; }, 0);
      var lijst = punten();
      if (!lijst.length) { klaar(); return; }
      /* Zwiep: de rij loopt in de richting van de beweging door (v in px per ms, ca. 250 ms uitloop). */
      var gewenst = rij.scrollLeft - v * 250;
      doel = lijst.reduce(function (a, b) { return Math.abs(b - gewenst) < Math.abs(a - gewenst) ? b : a; });
      if (Math.abs(rij.scrollLeft - doel) < 2) { klaar(); return; }
      rij.addEventListener('scroll', opGlij, { passive: true });
      veiligheid = setTimeout(klaar, 1500);
      rij.scrollTo({ left: doel, behavior: rustig.matches ? 'auto' : 'smooth' });
      opGlij();
    }
    rij.addEventListener('pointerup', los);
    rij.addEventListener('pointercancel', los);
    rij.addEventListener('click', function (e) {
      if (gesleept) { e.preventDefault(); e.stopPropagation(); gesleept = false; }
    }, true);
    rij.addEventListener('dragstart', function (e) { if (desktop.matches) e.preventDefault(); });
    /* Ook bij binnenkomen met de muis: een rij kan na het laden kaarten krijgen (kopieën in lx-ugc). */
    rij.addEventListener('pointerenter', markeer);
    if ('ResizeObserver' in window) new ResizeObserver(markeer).observe(rij);
    window.addEventListener('resize', markeer);
    markeer();
  }
  function alles() {
    document.querySelectorAll('[data-lx-carrousel]').forEach(init);
    document.querySelectorAll('.lx-carrousel__rij, .lx-ugc__rij').forEach(initSleep);
    document.querySelectorAll('.lx-loop').forEach(initLoop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  document.addEventListener('shopify:section:load', alles);
})();
